import React from "react";
import { Skeleton } from "antd";
import { generateGUID } from "../../../utils/MainHelper.js";

function TreeMapSkeleton() {
    return (
        <div
            className="d-flex"
            style={{
                width: "100%",
                height: "100%"
            }}
        >
            <div
                className="d-flex-col justify-content-between"
                style={{
                    width: "40%",
                    height: "100%"
                }}
            >
                {
                    ("four".split("")).map(() => (
                        <Skeleton.Avatar
                            key={generateGUID()}
                            className="flex-1"
                            active
                            size="large"
                            shape="square"
                            style={{
                                height: "99%",
                                width: "99.5%"
                            }}
                        />
                    ))
                }
            </div>
            <div
                className="d-flex-col"
                style={{
                    width: "60%",
                    height: "100%"
                }}
            >
                <div className="d-flex justify-content-between flex-1">
                    <Skeleton.Avatar
                        className="flex-1"
                        active
                        size="large"
                        shape="square"
                        style={{
                            height: "99%",
                            width: "99%"
                        }}
                    />
                    <Skeleton.Avatar
                        className="flex-1"
                        active
                        size="large"
                        shape="square"
                        style={{
                            height: "99%",
                            width: "99%"
                        }}
                    />

                </div>
                <div className="d-flex justify-content-between flex-1">
                    <Skeleton.Avatar
                        className="flex-2"
                        active
                        size="large"
                        shape="square"
                        style={{
                            height: "99%",
                            width: "99%"
                        }}
                    />
                    <Skeleton.Avatar
                        className="flex-1"
                        active
                        size="large"
                        shape="square"
                        style={{
                            height: "99%",
                            width: "99%"
                        }}
                    />

                </div>
                <div className="d-flex justify-content-between flex-1">
                    <Skeleton.Avatar
                        className="flex-1"
                        active
                        size="large"
                        shape="square"
                        style={{
                            height: "99%",
                            width: "99%"
                        }}
                    />
                    <Skeleton.Avatar
                        className="flex-1"
                        active
                        size="large"
                        shape="square"
                        style={{
                            height: "99%",
                            width: "99%"
                        }}
                    />

                </div>
            </div>

        </div>
    );
}

export default TreeMapSkeleton;
